import { useState, useEffect } from 'react'
import ExternalLayout from 'components/layouts/external'
import { Form } from 'react-final-form'
import Input from 'components/forms/input'
import { signUp } from 'services/auth'
import Router from 'next/router'
import { redirect } from 'services/util'
import { checkForAuthToken, getCurrentUser } from 'services/auth'
import Seo from 'components/seo'
import Link from 'next/link'
import { getCookie, removeCookie } from 'services/cookies'
import load from 'load-script'
import Recaptcha from 'react-recaptcha'
import { FREE_CREDITS } from 'services/constants'

const Signup = ({ initialValues }) => {
  const [error, setError] = useState('')
  const [promoValue, setPromoValue] = useState(0)
  const [captcha, setCaptcha] = useState(null)

  useEffect(() => {
    setTimeout(function () {
      const promo = Number(getCookie('promo'))
      setPromoValue(promo > 0 ? promo : FREE_CREDITS)
    }, 10)
  }, [promoValue])

  useEffect(() => {
    load('https://www.google.com/recaptcha/api.js?render=explicit', (err, script) => {})
  }, [])

  const onSubmit = async values => {
    setError('')

    const { data, message } = await signUp({
      ...values,
      promoValue: 0,
      captcha,
      source: localStorage.getItem('refSource'),
    })

    if (message) {
      return setError(message)
    }

    removeCookie('promo')

    if (data && data._id) {
      Router.push('/send')
    }
  }

  return (
    <>
      <Seo
        title="Handwrite | Sign Up"
        description="Register for a handwrite.io account"
        canonicalPath="signup"
      />
      <div className="auth-page">
        {/* {promoValue > 0 && (
          <p
            className="banner banner-green with-check mb-2 d-block"
            style={{ maxWidth: 500, margin: 'auto' }}>
            <strong>VIP Offer Applied</strong>
            <span className="pull-right">
              {promoValue} free credit{promoValue > 1 && 's'}
            </span>
          </p>
        )} */}
        <div className="well">
          <h1 className="color-blue text-center mb-3">Sign Up</h1>
          <Form onSubmit={onSubmit} initialValues={initialValues}>
            {({ handleSubmit, submitting }) => (
              <form id="new_sign_up" onSubmit={handleSubmit}>
                <Input name="email" type="email" label="Email" disabled={initialValues.email} required />
                <div className="inline-fields">
                  <Input name="firstName" type="text" required label="First Name" />
                  <Input name="lastName" type="text" required label="Last Name" />
                </div>
                <Input name="password" type="password" label="Password" required />

                <Recaptcha
                  sitekey="6LdjK-cUAAAAAHjT0zsMw0Yka_p0fqhIwSPAfvn5"
                  render="explicit"
                  elementID="captcha-wrapper"
                  verifyCallback={token => {
                    setCaptcha(token)
                  }}
                  onloadCallback={y => {
                    console.log('loaded', y)
                  }}
                />

                <div className="text-center mb-1">
                  <button type="submit" className="btn btn-blue btn-lg" disabled={submitting}>
                    Sign Up
                  </button>
                </div>
                <span className="d-block mt-2 error-text">{!!error && error}</span>
              </form>
            )}
          </Form>
        </div>

        <p className="body-text mt-4 text-center">
          Already have an account?{' '}
          <Link href="/login">
            <a className="link">Log In</a>
          </Link>
        </p>
      </div>
    </>
  )
}

Signup.getInitialProps = async ({ req, res, query }) => {
  if (checkForAuthToken(req)) {
    const currentUser = await getCurrentUser()

    if (currentUser) {
      removeCookie('promo')
      redirect('/send', res)
    }
  }

  return {
    initialValues: {
      teamId: query.t,
      email: query.e,
    },
  }
}

Signup.Layout = ExternalLayout

export default Signup
